<script lang="ts" setup>
  import { ExternalRoute } from "@/constants/externalRoute"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>We're sorry to hear about your smart meter issues. Maybe we can help?</h4>
  <p>
    If you are concerned your smart meter won't work after you switch to us,
    don't worry it should retain all functionality. We can even 'wake up' the
    older first-generation smart meters to get them to work for us.
  </p>
  <p>
    If your smart meter has other issues, we can still help - just
    <Link class="link text-primary-600" :to="ExternalRoute.contactUs">
      get in touch with our customer support team here
    </Link>
    , or on
    <Link class="link text-primary-600" to="mailto:help@so.energy"
      >help@so.energy</Link
    >
    or
    <Link class="link text-primary-600" to="tel:0330 111 5050"
      >0330 111 5050</Link
    >
    (Mon-Fri 9am-5pm) and let us know the problem.
  </p>
</template>
